import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'deleteManyCampaignCodes'

export default (codeIds) => (asyncAction(
  name,
  CampaignsService.deleteManyCampaignCodes,
  { codeIds }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/deleteManyCampaignCodes.js